import { clients } from 'lib/https';
import { getConfigurationSettings } from 'services/configuration-service';

import {
  MENTION_SEARCH_TYPES_PARAM,
  type IMentionsSearchParams,
  type MentionsSearchApiResponse,
} from '../types/mentions.service.type';

export class MentionsService {
  async search(
    params: IMentionsSearchParams,
    blocksKey: string
  ): Promise<MentionsSearchApiResponse> {
    const config = await getConfigurationSettings();
    const searchParams = new URLSearchParams();
    const query = params.q?.trim();
    if (query) {
      searchParams.set('q', query);
    }
    const types = params.types?.length ? params.types : [...MENTION_SEARCH_TYPES_PARAM];
    searchParams.set('types', types.join(','));
    if (params.surface?.trim()) {
      searchParams.set('surface', params.surface.trim());
    }

    const qs = searchParams.toString();
    const url = `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.mentionsSearch}${qs ? `?${qs}` : ''}`;
    return clients.get<MentionsSearchApiResponse>(url, blocksKey);
  }
}

export const mentionsService = new MentionsService();
